import { Component, Input } from "@angular/core";
import { IContentControlledItemSettings } from 'app/js/src/domain/content-control/settings';

@Component({
  selector: "evrideo-content-control-studio-settings",
  templateUrl: "./content-control-studio-settings.component.html",
  styleUrl: "./content-control-studio-settings.component.scss",
})
export class ContentControlStudioSettingsComponent {
  @Input() settings: IContentControlledItemSettings;
  ngOnInit() {
    this.setupUI();
  }
  ngOnChanges() {
    this.setupUI();
  }
  private setupUI() {
    if (this.settings) {
    }
  }
  public onAIDetectionScalingFactorChange(v: number) {
    this.settings.aiDetections.scalingFactor = v;
  }
}
